/**
 * Environment-Badge — zeigt dem Nutzer, ob er gerade die Vorschau- oder die
 * Live-Version sieht. Verhindert Verwirrung wenn Bugs/Features nur in einer
 * der beiden Umgebungen vorhanden sind.
 */
export const EnvBadge = () => {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname || "";
  // Preview hosts always contain "preview.emergentagent.com"
  const isPreview = host.includes("preview.emergent");
  // Local development
  const isLocal = host === "localhost" || host === "127.0.0.1";
  // Production = anything else (e.g. heating-sales-app.emergent.host)

  if (isLocal) {
    return (
      <span
        data-testid="env-badge-local"
        className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-bold tracking-widest uppercase bg-blue-500/20 border border-blue-500/40 text-blue-200"
        title="Lokale Entwicklung"
      >
        LOKAL
      </span>
    );
  }
  if (isPreview) {
    return (
      <span
        data-testid="env-badge-preview"
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-bold tracking-widest uppercase bg-amber-500/20 border border-amber-500/50 text-amber-200"
        title="Vorschau-Umgebung — Änderungen sind hier sofort sichtbar, in der Live-App erst nach Deploy."
      >
        Vorschau
      </span>
    );
  }
  // Production
  return (
    <span
      data-testid="env-badge-live"
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-bold tracking-widest uppercase bg-[#00E575]/15 border border-[#00E575]/50 text-[#00E575]"
      title="Live-Umgebung (Produktion)"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#00E575] animate-pulse" />
      Live
    </span>
  );
};
